<th
  *ngIf="operationItems ? true : false"
  pFrozenColumn
  [frozen]="true"
  alignFrozen="left"
  [style]="'min-width:' + operationItemsWidth + 'px;' + 'max-width:' + operationItemsWidth + 'px;'"
>
  <div
    class="flex justify-content-center align-items-center min-w-full"
    style="font-size: 1.8rem"
  >
    <i class="fa fa-cog"></i>
  </div>
</th>
<th
  *ngFor="let col of columns"
  [pSortableColumn]="col.field"
  pReorderableColumn
  [style]="
    'min-width:' + (col.width ? col.width + 'px' : columnDefaultWidth + 'px')
  "
>
  <mx-table-header-cell
    [column]="col"
    class="flex min-w-full"
  ></mx-table-header-cell>
</th>
